/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Related_LinkInputs */

const en_road_dude_related_link = /** @type {(inputs: Road_Dude_Related_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore Hotel Lobby AI`)
};

const zh_road_dude_related_link = /** @type {(inputs: Road_Dude_Related_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体验 Hotel Lobby AI`)
};

/**
* | output |
* | --- |
* | "Explore Hotel Lobby AI" |
*
* @param {Road_Dude_Related_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_related_link = /** @type {((inputs?: Road_Dude_Related_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Related_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_related_link(inputs)
	return zh_road_dude_related_link(inputs)
});
export { road_dude_related_link as "road_dude.related.link" }